export class Balance {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      availableAdvance: this.fields?.availableAdvance?.displayValue,
      advanceLimit: this.fields?.advanceLimit?.displayValue
    };
  }
}
